import { Observable } from "./Observable.js";
import { Subscription } from "./Subscription.js";
class Subject extends Observable {
  constructor() {
    super((subscriber) => {
      return this._subscribeToSubject(subscriber);
    });
    this._observers = /* @__PURE__ */ new Set();
    this._isStopped = false;
    this._hasError = false;
  }
  _subscribeToSubject(subscriber) {
    const partialObserver = {
      next: subscriber.next.bind(subscriber),
      error: subscriber.error.bind(subscriber),
      complete: subscriber.complete.bind(subscriber)
    };
    if (this._isStopped) {
      if (this._hasError) {
        partialObserver.error?.(this._error);
      } else {
        partialObserver.complete?.();
      }
      return Subscription.EMPTY;
    }
    this._observers.add(partialObserver);
    return new Subscription(() => {
      this._observers.delete(partialObserver);
    });
  }
  next(data) {
    if (this._isStopped) {
      return;
    }
    this._observers.forEach((observer) => {
      observer.next?.(data);
    });
  }
  error(err) {
    if (this._isStopped) {
      return;
    }
    this._hasError = true;
    this._error = err;
    this._isStopped = true;
    this._observers.forEach((observer) => observer.error?.(err));
    this._observers.clear();
  }
  complete() {
    if (this._isStopped) {
      return;
    }
    this._isStopped = true;
    this._observers.forEach((observer) => observer.complete?.());
    this._observers.clear();
  }
  asObservable() {
    return new Observable((subscriber) => {
      return this._subscribeToSubject(subscriber);
    });
  }
}
export {
  Subject
};
//# sourceMappingURL=Subject.js.map
